module.exports = __webpack_public_path__ + "img/img80.87d3e5f5.png";